class ConditionalCarousel {
    constructor() {
        console.log('🔍 [1] Constructor iniciado');
        this.cartItems = [];
        this.swiper = null;
        this.kitsCollectionId = 'all-solar';
        this.polarizadosCollectionId = 'polarizados';

        // Agregamos un setTimeout para asegurar que todo está cargado
        setTimeout(() => {
            console.log('🔍 [2] Iniciando después de timeout');
            this.init();
        }, 1000);
    }

    async init() {
        try {
            await this.getCartItems();

            const collectionId = this.determineCollectionToShow();

            if (collectionId) {
                await this.loadProducts(collectionId);
                this.initSwiper();
            } else {
                console.log('❌ No se encontró una colección para mostrar');
            }
        } catch (error) {
            console.error('❌ Error en init():', error);
        }
    }

    async getCartItems() {
        try {
            const response = await fetch('/cart.js');

            const cart = await response.json();

            if (cart && cart.items) {
                this.cartItems = cart.items;
            } else {
                console.log('⚠️ El carrito está vacío o mal formateado');
            }
        } catch (error) {
            console.error('❌ Error al obtener items del carrito:', error);
        }
    }

    determineCollectionToShow() {
        if (!this.cartItems || this.cartItems.length === 0) {
            console.log('⚠️ No hay items en el carrito para analizar');
            return null;
        }

        // Convertir tipos a minúsculas y log de cada uno
        const types = this.cartItems.map(item => {
            const type = item.product_type.toLowerCase();
            console.log('Tipo de producto encontrado:', type);
            return type;
        });

        // Verificar cada tipo
        const hasOftalmic = types.some(type => {
            const isOftalmic = type.includes('oftalmic') || type.includes('oftálmico');
            if (isOftalmic)
                return isOftalmic;
        });

        const hasSolar = types.some(type => {
            const isSolar = type.includes('solar') || type.includes('solares');
            if (isSolar)
                return isSolar;
        });

        const hasContactLens = types.some(type => {
            const isContactLens = type.includes('lentes de contacto') || type.includes('contacto');
            if (isContactLens)
                return isContactLens;
        });


        if (hasOftalmic || hasSolar) {
            return this.kitsCollectionId;
        } else if (hasContactLens) {
            return this.polarizadosCollectionId;
        }

        console.log('⚠️ No se encontró coincidencia con ninguna colección');
        return null;
    }

    async loadProducts(collectionId) {
        try {
            console.log('🔍 [13] Cargando productos de colección:', collectionId);
            const response = await fetch(`/collections/${collectionId}/products.json`);
            const products = await response.json();
            console.log(products);

            const carouselContainer = document.getElementById('cart-conditional-carousel-container');
            if (!carouselContainer) {
                return;
            }

            // Crear contenedor Swiper
            carouselContainer.innerHTML = `
          <div class="swiper">
            <div class="swiper-wrapper"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        `;

            const swiperWrapper = carouselContainer.querySelector('.swiper-wrapper');
            swiperWrapper.innerHTML = products.products.map(product => `
          <div class="swiper-slide">
            <div class="product-card">
              <img src="${product.images[0]?.src || ''}" alt="${product.title}">
              <h3 class="titleDPD">${product.title}</h3>
              <p class="pricePRO">${this.formatPrice(product.variants[0].price)}</p>
              <div class="add-to-cart-btn" 
                data-variant-id="${product.variants[0].id}"
                onclick="window.conditionalCarousel.addToCart('${product.variants[0].id}')">
                Agregar al carrito
              </div>
            </div>
          </div>
        `).join('');

        } catch (error) {
        }
    }

    initSwiper() {
        try {
            console.log('🔍 [16] Iniciando Swiper');
            const swiperContainer = document.querySelector('#cart-conditional-carousel-container .swiper');

            if (!swiperContainer) {
                throw new Error('No se encontró el contenedor de Swiper');
            }

            this.swiper = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 30,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        centeredSlides: true,
                        centeredSlidesBounds: true,
                    },
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        centeredSlides: true,
                        centeredSlidesBounds: true,
                    }
                },
                on: {
                    init: function () {
                    },
                    observerUpdate: function () {
                    }
                }
            });
        } catch (error) {
        }
    }
    async addToCart(variantId) {
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [
                        {
                            quantity: 1,
                            id: variantId,
                            properties: {
                                "Agregado": "En carrito", // Agregar el atributo "Venta"
                            },
                        },
                    ],
                }),
            });

            console.log('🔍 [19] Respuesta del servidor:', response);

            if (response.ok) {
                console.log('✅ Producto agregado al carrito correctamente');
                window.location.reload();
            } else {
                console.error('❌ No se pudo agregar al carrito, status:', response.status);
            }
        } catch (error) {
            console.error('❌ Error en addToCart:', error);
        }
    }

    formatPrice(price) {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN'
        }).format(price);
    }
}

// Estilos CSS
const styles = `
    /* Estilos del contenedor principal */
    #cart-conditional-carousel-container {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px;
          max-height: 320px;
    }
  
    /* Estilos de Swiper */
    .swiper {
      width: 100%;
      height: 100%;
      min-height: 400px;
      visibility: visible !important;
    }
  
    .swiper-wrapper {
      height: auto !important;
    }
  
    .swiper-slide {
      height: auto;
      display: flex;
      justify-content: center;
    }
  
    /* Estilos de los botones de navegación */
    .swiper-button-next,
    .swiper-button-prev {
      color: #000;
      background-color: rgba(255, 255, 255, 0.8);
      padding: 30px;
      border-radius: 50%;
      transform: scale(0.7);
    }
  
    .swiper-button-next::after,
    .swiper-button-prev::after {
      font-size: 20px;
      font-weight: bold;
    }
  
    /* Estilos de las tarjetas de productos */
    .product-card {
      padding: 1rem;
      border: 1px solid #e2e2e2;
      border-radius: 8px;
      text-align: center;
      margin: 0px;
    }
  .swiper-button-next:after, .swiper-button-prev:after{
  color:var(--Rojo-185-C, #e40d2c);
  }
    .product-card img {
          max-width: 100%;
    height: 120px;
    margin-bottom: 1rem;
    object-fit: contain;
    }
  
    .add-to-cart-btn {
          display: flex;
    width: auto;
    height: auto;
    padding: 10px 20px 6px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    border-radius: 8px;
    background: var(--Rojo-185-C, #e40d2c);
    color: #fff;
    font-family: ITC Avant Garde Gothic;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: .96px;
    text-transform: uppercase;
    }
  
    .add-to-cart-btn:hover {
      background-color: #333;
      background: #fff;
      border:1px soid var(--Rojo-185-C, #e40d2c);
    color: var(--Rojo-185-C, #e40d2c);
    }
  
    .swiper-button-next,
    .swiper-button-prev {
      color: #000;
    }
  `;

// Verificar si el DOM está listo
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
} else {
    initCarousel();
}

function initCarousel() {
    console.log('🔍 [0] Iniciando setup del carousel');

    // Insertar estilos
    const styleSheet = document.createElement('style');
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);

    // Verificar que el contenedor existe
    const container = document.getElementById('cart-conditional-carousel-container');
    if (!container) {
        console.error('❌ No se encuentra el contenedor del carousel');
        return;
    }

    // Inicializar carousel
    console.log('🔍 Creando instancia del carousel');
    window.conditionalCarousel = new ConditionalCarousel();
}